import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseHttpService } from '@app/core/services/base-http.service';
import { RentalAgreementHistoryListItem } from './rental-agreement-history.model';

@Injectable({
  providedIn: 'root'
})
export class RentalAgreementsHistoryService extends BaseHttpService {
  getRentalAgreementHistory(rentalAgreeementUid: string): Observable<RentalAgreementHistoryListItem[]> {
    return this.httpClient.get<RentalAgreementHistoryListItem[]>(
      `${this.baseApiUrl}/api/rentalAgreementHistory/${rentalAgreeementUid}`
    );
  }
}
